import { fetchIsSampleProject } from './fetch-is-sample-project/index.tsx';

export const actions = {
	fetchIsSampleProject,
};
